export default __webpack_public_path__ + "static/media/truck-travel.ace4b416.png";